module.exports = __webpack_public_path__ + "img/IMG_0459_L_Foamcore_MockedUp.11a1c951.jpg";